module.exports = __webpack_public_path__ + "static/media/header-cart.03f781cd.svg";